import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, ViewChildren, QueryList, ElementRef, OnDestroy, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AppService } from 'app/main/services/app.service';
import { CartService } from 'app/main/services/cart.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'product-cart-page',
	templateUrl: './shopping-cart.component.html',
	styleUrls: ['./shopping-cart.component.scss']
})
export class ProductShoppingCartPageComponent implements OnInit, OnDestroy {

	@Input() cartItem: any;
	@Output() _previewing: EventEmitter<boolean>;

	_unsubscribeAll: Subject<any>;
	formGroup: FormGroup;

	constructor(
		public appService: AppService,
		public cartService: CartService,
		private http: HttpClient,
		private fb: FormBuilder){
			this._unsubscribeAll = new Subject<any>();
			this._previewing = new EventEmitter<boolean>();
		}

	ngOnInit(): void {
		this.formGroup = this.fb.group({ ADT: new FormControl(this.cartItem.trip_booking.participant_count) });

		this.formGroup.get('ADT')
		.valueChanges
		.subscribe((fieldValue: any) => {
			const data = {};
			data['product_id'] = this.cartItem.product_id;
			data['participants'] = {ADT: fieldValue};

			const prev = this.formGroup.value.ADT;
			const next = fieldValue;
			let counter = 0;

			if (next > prev) {
				counter = (next - prev);
				this.onIncrement(data, counter);
			} else if (prev > next) {
				counter = prev - next;
				this.onDecrement(counter);
			}
		});
	}

	ngOnDestroy(): void{
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	increment(): void{
		const field = this.formGroup.controls['ADT'];
		field.setValue(field.value + 1);
	}

	decrement(): void{
		const field = this.formGroup.controls['ADT'];
		if (field.value == 1) return;
		field.setValue(field.value - 1);
	}

	onIncrement(data: any, counter: number): void{
		this._previewing.emit(true);
		this.http.post(this.appService.getBaseServerAddress() + '/product-booking/preview', data)
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: (preview: any) => {
				this._previewing.emit(false)

				if (preview.is_valid) return;
				/**
				 * update cart
				 */
				this.cartService.updateCart(this.cartItem, {
					date: moment().format('DD/MM/YYYY'),
					adt_counter: counter,
					chd_counter: 0,
					inf_counter: 0,
					snr_counter: 0,
					trip_booking_id: this.cartItem.trip_booking_id,
					nation_code: 'GB',
					target: 'product',
					scenario: 'increment'
				});
			},
			error: (exception) => {
				this._previewing.emit(false);
				/**
				 * catch error
				 */
				console.warn(exception);
			}
		});
	}

	onDecrement(counter: number): void{
		/**
		 * update cart without preview
		 */
		this.cartService.updateCart(this.cartItem, {
			date: moment().format('DD/MM/YYYY'),
			adt_counter: counter,
			chd_counter: 0,
			inf_counter: 0,
			snr_counter: 0,
			trip_booking_id: this.cartItem.trip_booking_id,
			nation_code: 'GB',
			target: 'product',
			scenario: 'decrement'
		});
	}
}
